import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import "./contactme.css"

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function Contactme() {
  const form = useRef();
  const [open, setOpen] = React.useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_9euzapx', 'template_vfvtzy1', form.current, 'lzSQTF_zIM07Bp4yK')
      .then((result) => {
        console.log(result.text);
        console.log("Email sent");
        setOpen(true); // Set open to true to display the Snackbar
       
        
      }, (error) => {
        console.log(error.text);
      });
  };

  


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };





  return (
    <div className='cnt-page'>
    <div className='form-position'>
      <form ref={form} onSubmit={sendEmail}>
        <h1 className='center-txt'>Contact Me</h1>
        <div>
          <label className='Label-name'>Name</label>
          <input type="text" name="from_name"  placeholder='Enter your Name'/>


        </div>
        <div>
          <label className='Label-email'>Email</label>
          <input type="email" name="reply_to" placeholder='Enter your Email' />

        </div>

        <div>
          <label className='Message'>Message</label>
          <textarea name="message" className='txt-area' placeholder='Enter a Message' />

        </div>



        <input type="submit" value="Send" className='btn-submit' />
        <p style={{color:"white", padding:"10px"}}>Click on the submit button above to verify if the email has been sent or not</p>
      </form>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Successfully Sent the Email
        </Alert>
      </Snackbar>

    </div>
    </div>

  );
}


